import './AppLayout.less';
import * as React from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import CornerRibbon from 'react-corner-ribbon';
import { L } from '../../lib/abpUtility';
import ProtectedRoute from '../../components/Router/ProtectedRoute';
import { appRouters } from '../Router/router.config';
import utils from '../../utils/utils';

import {
  AppContainer,
  AbbBar,
  AppHeader,
  AppTopNavi,
  AppTopNaviItem,
  AppContent,
  AppFooter,
  LoadingIndicator,
  Icon,
  Logo,
} from '@abb/abb-common-ux-react';

import SiderMenu from '../SiderMenu';
import LanguageSelect from '../LanguageSelect';
import { Alert, BackTop, Dropdown, Menu, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { AuthContextProps, withAuth } from 'oidc-react';
import { Stores } from '../../stores';
import { inject } from 'mobx-react';
import SessionStore from '../../stores/sessionStore';
import Exception from './../../scenes/Exception/index';
import { clearAllStorage } from '../../services/httpService';
import { dnsExternalEntryPath, isDnsExternalEntry } from '../../lib/dnsExternalEntry';
import { MSPRoute } from '../Router/router.config';
import ContactUs from '../ContactUs';
import {
  AnnouncementServiceProxy,
  BindingAuthenticateDto,
  GetAnnouncementDto,
  ChangeUserLanguageDto,
  UserDto,
  UserServiceProxy,
} from '../../services/serviceProxy';
import Link from 'antd/lib/typography/Link';
import GetSupport from '../GetSupport';
import PendingTask from '../PendingTask';
import AbbIcon from '../../packages/AbbIcon';

declare var abp: any;

function isAbbEmail(email?: string | null) {
  const domain = (email || '').trim().toLowerCase().split('@').pop() || '';
  return domain === 'abb.com' || domain.endsWith('.abb.com');
}
export interface IAppLayoutProps extends AuthContextProps {
  history?: any;
  location?: any;
  sessionStore?: SessionStore;
  accountInfos: UserDto[];
  bindingState: boolean;
  alertMessage: GetAnnouncementDto;
}
@inject(Stores.SessionStore)
class AppLayout extends React.Component<IAppLayoutProps> {
  private _userServiceProxy = new UserServiceProxy();
  private _announcementService = new AnnouncementServiceProxy();

  notificationCounter = 0;
  state = {
    notifications: [],
    accountInfos: [],
    bindingState: null,
    refresh: false,
    alertMessage: null,
  };

  componentDidMount = async () => {
    await this.props.sessionStore!.getCurrentLoginInformations();
    await this.setSystemType();
    await this.handleShowAlertMessage();
    this.setState({ refresh: true });

    // if (!abp.session.userId) {
    //查询账号信息
    this._userServiceProxy.getBindingUserInfos().then((resp) => {
      this.setState({
        accountInfos: resp.result,
        bindingState:!resp.hasIDP
      });
    });
    // }
  };

  setSystemType = async () => {
    if (!abp.utils.getCookieValue('Abp.Login.FirstReload')) {
      abp.utils.setCookieValue(
        'Abp.Login.FirstReload',
        'YES',
        null,
        abp.appPath
      );
      let languageName = 'zh-Hans';
      if(abp.auth.isGranted("Pages.IWorld.HomePage") == true) {
        abp.utils.setCookieValue(
          'Abp.Localization.CultureName',
          'en',
          null,
          abp.appPath
        );
        languageName = 'en';
        abp.utils.setCookieValue(
          'Abp.Login.UserType',
          'IWorld',
          null,
          abp.appPath
        )
      } else {
        abp.utils.setCookieValue(
          'Abp.Localization.CultureName',
          'zh-Hans',
          null,
          abp.appPath
        );
        languageName = 'zh-Hans';
        abp.utils.setCookieValue(
          'Abp.Login.UserType',
          'MSP',
          null,
          abp.appPath
        );
      }
      if (abp.session.userId) {
        let dto = new ChangeUserLanguageDto();
        dto.languageName = languageName;
        await this._userServiceProxy.changeLanguage(dto);
        window.location.reload();
      }
    }
  }

  get notificationManager() {
    return {
      remove: (id) => {
        const notifications = this.state.notifications.slice();
        const ix = notifications.findIndex((i) => i.id === id);
        if (ix > -1) {
          notifications[ix].isClosing = true;
        }
        this.setState({ notifications });
        setTimeout(() => this.setState({ notifications: this.state.notifications.filter((i) => i.id !== id) }), 500);
      },
    };
  }

  fireNotification = (data) => {
    const newNotification = {
      id: 'notification-' + this.notificationCounter++,
      buttons: data.buttons,
      type: data.type,
      severity: data.severity,
      text: data.text,
      timeout: data.timeout,
    };
    const newNotifications = this.state.notifications.concat(newNotification);
    this.setState({ notifications: newNotifications });
  };

  //注销
  handleSignOut = () => {
    Modal.confirm({
      title: L('Logout'),
      icon: <ExclamationCircleOutlined />,
      content: L('AreYouSure'),
      okText: L('Yes'),
      cancelText: L('No'),
      onOk: async () => {
        if (this.isExternalEntry()) {
          clearAllStorage();
          window.location.replace('/account/external-entry?ended=1');
          return;
        }
        const { userData, signOutRedirect } = this.props;
        if (userData) {
          clearAllStorage();
          await signOutRedirect({ id_token_hint: userData.id_token });
        }
      },
    });
  };

  //绑定账号
  handleBinding = async (item: UserDto) => {
    if (item.isDisabled) {
      /* empty */
    } else {
      const { signIn } = this.props;
      const data = new BindingAuthenticateDto();
      data.userId = item.id;
      this._userServiceProxy.bindingAuthenticate(data).then(() => {
        signIn();
      });
    }
  };

  //注销返回登陆
  isExternalEntry = () => {
    return isDnsExternalEntry() || this.props.userData?.profile?.sub === 'dns-external';
  };

  findRoute = (routes: MSPRoute[], path: string): MSPRoute | undefined => {
    for (const route of routes) {
      if (route.path === path) {
        return route;
      }
      if (route.children) {
        const found = this.findRoute(route.children, path);
        if (found) {
          return found;
        }
      }
    }
    return undefined;
  };

  handleSignOut1 = async () => {
    if (this.isExternalEntry()) {
      clearAllStorage();
      window.location.replace('/account/external-entry?ended=1');
      return;
    }
    const { userData, signOutRedirect } = this.props;
    if (userData) {
      clearAllStorage();
      await signOutRedirect({ id_token_hint: userData.id_token });
    }
  };

  //显示全局提示横幅
  handleShowAlertMessage = async () => {
    //   let alertMessage = localStorage.getItem("alertMessageKey");
    //   // let alertMessage = localStorage.getItem("closeAlertMessageKey");
    //   if (!alertMessage) {
    //获取系统横幅
    const alertData = await this._announcementService.getLatestAlertAnnouncement();
    if (alertData != null && alertData.id) {
      this.setState({ alertMessage: alertData });
      // alertMessage = alertData;
      // }
      // localStorage.removeItem("firstLogin")
    }
  };

  //关闭全局提示横幅
  handleCloseAlertMessage = async () => {
    if (localStorage.getItem('firstLogin')) {
      const _userService = new UserServiceProxy();
      _userService.createLastLoginTime().then(() => {
        localStorage.removeItem('firstLogin');
      });
    }
  };

  render() {

    const {
      location: { pathname },
      sessionStore: { currentName },
    } = this.props;
    const showGetSupport = isAbbEmail(this.props.sessionStore?.currentLogin?.user?.emailAddress);
    const externalEntry = this.isExternalEntry();
    const externalRoute = externalEntry ? this.findRoute(appRouters, dnsExternalEntryPath) : undefined;

    const binding = (
      <div style={{ padding: '67px 0', height: '100%', backgroundColor: '#f5f5f5' }}>
        <div
          style={{
            padding: '20px 40px 30px 40px',
            backgroundColor: '#fff',
            borderRadius: '8px',
            margin: '0 auto',
            maxWidth: '500px',
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              paddingTop: '21px',
            }}
          >
            <header>
              <h1 style={{ marginTop: 0, textAlign: 'left', fontSize: '32px' }}>选择帐户</h1>
            </header>
            <div id="content">
              <div>
                <div className="accountGroup">
                  {this.state.accountInfos!=null && this.state.accountInfos.map((item, index) => (
                    <a key={index} onClick={() => this.handleBinding(item)}>
                      <Icon
                        name={item.isDisabled || !item.isActive ? 'abb/lock-closed' : 'abb/user'}
                        sizeClass="large"
                        color="#000"
                      />
                      <span className="account">
                        <span>{item.userName}</span>
                        <span>{item.emailAddress}</span>
                      </span>
                      {/* <Icon name="abb/caret-right" sizeClass="large" /> */}
                    </a>
                  ))}
                </div>
                <div className="logout">
                  <a onClick={this.handleSignOut1}>« 回到登录</a>
                </div>
              </div>
              <div className="footer">
                <div className="wrapper">请选择一个账号登录（若状态为锁定，请联系管理员）。</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

    //全屏加载等待页
    const loading = (
      <div style={{ padding: '0', height: '100%', backgroundColor: '#f5f5f5' }}>
        <LoadingIndicator type="bar" determinate={false} color="red" sizeClass="medium" />
        <div
          style={{
            height: '100px',
            width: '200px',
            margin: '23% auto',
          }}
        >
          <Logo color="red" />
        </div>
      </div>
    );

    const env = process.env.REACT_APP_PROJECT_ENV;

    const cornerRibbon = env && env.toUpperCase() !== 'PROD' && (
      <CornerRibbon
        position="top-right" // OPTIONAL, default as "top-right"
        // position="top-left" // OPTIONAL, default as "top-right"
        fontColor="#f0f0f0" // OPTIONAL, default as "#f0f0f0"
        backgroundColor="#ff000f" // OPTIONAL, default as "#2c7"
        containerStyle={{}} // OPTIONAL, style of the ribbon
        style={{ fontSize: '1.2rem', position: 'fixed', zIndex: '1000' }} // OPTIONAL, style of ribbon content
        className="" // OPTIONAL, css class of ribbon
      >
        {env.toUpperCase()} Environment
      </CornerRibbon>
    );

    //全局提示横幅
    const alertMessage =
      !externalEntry && this.state.alertMessage != null ? (
        <Alert
          message={
            <Link
              style={{ color: 'black' }}
              href={`/systemAnnouncement/systemAnnouncementDetails?id=${this.state.alertMessage.id}`}
            >
              {this.state.alertMessage.title}
            </Link>
          }
          type="info"
          showIcon
          banner
          closable
          onClose={this.handleCloseAlertMessage}
        />
      ) : (
        ''
      );

    const layout = (
      <>
        <div
          id="abb-header"
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 1,
          }}
        >
          {alertMessage}
          <AbbBar productName="ABB Motor Sales Portal" />
          <AppHeader style={{ boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2)' }}>
            <div style={{ float: 'left', width: '70%' }}>
              {externalEntry ? (
                <div style={{ lineHeight: '48px', paddingLeft: 24, fontSize: 16 }}>DNS附件查询打印下载</div>
              ) : (
                <SiderMenu />
              )}
            </div>
            <div style={{ width: '30%' }}>
              <AppTopNavi style={{ float: 'right', height: '100%' }}>
                {externalEntry ? null : <ContactUs />}
                {externalEntry || !showGetSupport ? null : <GetSupport />}
                {externalEntry ? null : <PendingTask />}
                {/*<LanguageSelect />*/}
                <Dropdown
                  trigger={['click']}
                  menu={{
                    items: [
                      {
                        key: 'logout',
                        label: L('Logout'),
                        icon: <AbbIcon name='abb_log-out' />,
                        onClick: this.handleSignOut,
                      },
                    ],
                  }}
                >
                  <AppTopNaviItem style={{width: '140'}} icon="abb/user" text={currentName} hasMenu={true}></AppTopNaviItem>
                </Dropdown>
              </AppTopNavi>
            </div>
          </AppHeader>
        </div>
        <AppContent style={{ overflow: 'auto' }}>
          <div style={{ padding: '8px', width: '100%' }}>
            <div style={{ padding: '10px 30px', minHeight: '100%', backgroundColor: '#FFFFFF' }}>
              {externalEntry ? (
                <Switch>
                  <Route
                    exact
                    path={dnsExternalEntryPath}
                    render={() => (
                      <ProtectedRoute component={externalRoute && externalRoute.component} permission={externalRoute && externalRoute.permission} />
                    )}
                  />
                  <Redirect to={dnsExternalEntryPath} />
                </Switch>
              ) : (
              <Switch>
                {pathname === '/' && <Redirect from="/" to="/dashboard" />}
                {appRouters
                  .filter((item) => !item.isLayout)
                  .map((route) => {
                    if (!route.children) {
                      return (
                        <Route
                          exact
                          key={route.name}
                          path={route.path}
                          render={() => <ProtectedRoute component={route.component} permission={route.permission} />}
                        />
                      );
                    } else {
                      return route.children
                        .filter((item) => !item.isLayout)
                        .map(
                          (croute): JSX.Element => (
                            <Route
                              exact
                              key={croute.name}
                              path={croute.path}
                              render={() => (
                                <ProtectedRoute component={croute.component} permission={croute.permission} />
                              )}
                            />
                          )
                        );
                    }
                  })}
                <Route component={Exception} />
              </Switch>
              )}
            </div>
          </div>
        </AppContent>
        <AppFooter style={{ textAlign: 'center' }}>
          © Copyright 2021-{new Date().getFullYear()} ABB |{' '}
          <a target="_blank" rel="noreferrer" href="http://beian.miit.gov.cn/">
            京ICP备13053479号-2
          </a>{' '}
          |{' '}
          <a target="_blank" rel="noreferrer" href="http://www.beian.gov.cn/portal/index">
            京公网安备 11010502037293号
          </a>
        </AppFooter>
        <BackTop />
      </>
    );

    return (
      <>
        <AppContainer>
          {cornerRibbon}
          {this.state.bindingState == null ? loading : this.state.bindingState ? binding : layout}
        </AppContainer>
      </>
    );
  }
}

export default withAuth(AppLayout);
